/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetch_user_contacts_action } from "../../_redux/action";
import { AuthContext } from "../../_hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { navigateRoutes } from "../../_config/route";

function useSavedContacts(props) {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [allContacts, setAllContacts] = useState();
  const [contactModalOpen, setContactModalOpen] = useState(null);
  const [deleteContact, setDeleteContact] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [selectedContactId, setSelectedContactId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { contactsData } = useSelector(
    (state) => state.fetch_user_contacts_reducer
  );

  useEffect(() => {
    if (user) {
      callAllContactsApi();
    }
  }, [user]);

  useEffect(() => {
    if (contactsData) {
      setAllContacts(contactsData);
    }
  }, [contactsData]);

  const callAllContactsApi = async () => {
    setLoading(true);
    await dispatch(fetch_user_contacts_action());
    setLoading(false);
  };

  const handleContactModalOpen = (item) => {
    if (item) {
      setSelectedContactId(item._id);
    }
    if (contactModalOpen) {
      callAllContactsApi();
    }
    setContactModalOpen((v) => !v);
  };

  const onContactDelete = async (item) => {
    setDeleteContact(item);
    setDeleteModalOpen((v) => !v);
  };
  const handleDeleteModalOpen = (item) => {
    if (item) {
      setDeleteContact(item);
    }
    if (deleteModalOpen) {
      callAllContactsApi();
    }
    setDeleteModalOpen((prev) => !prev);
  };

  const handleLoginClick = () => {
    navigate(navigateRoutes.signIn);
  };

  return {
    user,
    loading,
    allContacts,
    contactModalOpen,
    deleteContact,
    deleteModalOpen,

    onContactDelete,
    handleContactModalOpen,
    selectedContactId,
    handleDeleteModalOpen,
    handleLoginClick,
  };
}
export default useSavedContacts;
